export enum FoundStatus {
  SHELTER = 'shelter',
  COLLECTED = 'collected',
  STAYS_WITH_FINDER = 'stays_with_finder',
  SECURED = 'secured',
}